import { render, staticRenderFns } from "./TableSumReservations.vue?vue&type=template&id=6942db56&scoped=true&"
import script from "./TableSumReservations.vue?vue&type=script&lang=js&"
export * from "./TableSumReservations.vue?vue&type=script&lang=js&"
import style0 from "./TableSumReservations.vue?vue&type=style&index=0&id=6942db56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6942db56",
  null
  
)

export default component.exports